export default __webpack_public_path__ + "static/media/geo-pos.10215ca8.svg";